import React, { Component } from 'react'
import { Well, Button, ButtonToolbar } from '@sketchpixy/rubix'
import UserCredit from '../common/credit/UserCredit'
import Dialog from 'material-ui/Dialog'
import { REQUEST_PAYMENT_REQUEST } from '../../actions/actions'
import { NotificationManager } from 'react-notifications'
import { connect } from 'react-redux'
import { toEnglishDigits } from '../../helpers/nums'
import { PulseLoader } from 'halogen'
import { createFormFromObject, PriceWithWords } from '../../helpers/utility'
import persianize from 'persianize'
import RechargeCards, { CustomPriceCard } from '../common/RechargeCards'
import { appendToFormData, flattenArray, getErrors } from '../../helpers/utility'
import MoneyInput from '../common/MoneyInput'

const styles = {
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
}

const Toolbar = () => (
  <Well>
    <ButtonToolbar>
      <span>
        <span>مدیریت اعتبار</span>
      </span>
    </ButtonToolbar>
  </Well>
)

class StudentCreditPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rechargeModalIsOpen: false,
      rechargeAmount: '',
      selectedFromWidgets: false,
    }
  }

  closeModal = () => {
    this.setState({
      rechargeModalIsOpen: false,
      rechargeAmount: null,
      selectedFromWidgets: false,
    })
  }

  openModal = () => {
    this.setState({
      rechargeModalIsOpen: true,
    })
  }

  isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n)

  updateRechargeAmount = value => {
    // value is blank
    if (value === '') {
      this.setState({ rechargeAmount: '' })
      return
    }

    // value is normal english numbers
    if (this.isNumeric(value)) {
      this.setState({ rechargeAmount: value })
      return
    }

    // check for english and persian numbers
    const filteredDigits = value.split('').filter(char => {
      // check if it is persian number
      if (persianize.validator().number(char)) {
        return true
      }

      // check if it is english number
      if (this.isNumeric(char)) {
        return true
      }

      // it a non-number char
      return false
    })

    // if the value was all filtered, just set it blank
    if (filteredDigits.length === 0) {
      this.setState({ rechargeAmount: '' })
    } else {
      // convert all characters to english
      this.setState({ rechargeAmount: toEnglishDigits(value) })
    }
  }

  handlePayment = () => {
    const { rechargeAmount } = this.state

    if (!rechargeAmount || rechargeAmount === '0') {
      NotificationManager.warning('میزان شارژ حساب را مشخص کنید', null, 6000)
      return
    }

    return new Promise((resolve, reject) => {
      const formData = appendToFormData({ amount: rechargeAmount })
      this.props.dispatch({ type: REQUEST_PAYMENT_REQUEST, formData, resolve, reject })
    })
      .then(data => {
        this.handleRedirectToBankPaymentPage(data.pasargad, data.url)
      })
      .catch(this.notifyUserWithErrors)
  }

  handleRedirectToBankPaymentPage = (formField, postUrl) => {
    const paymentForm = createFormFromObject(formField, postUrl)
    document.body.appendChild(paymentForm)
    paymentForm.submit()
  }

  onRechargeCardClick = amount => {
    this.setState({
      rechargeModalIsOpen: true,
      rechargeAmount: amount,
      selectedFromWidgets: true,
    })
  }

  notifyUserWithErrors({ general_errors, form_errors }) {
    const flattenedErrors = [...flattenArray(general_errors), ...getErrors(form_errors)]
    for (let error of flattenedErrors) {
      NotificationManager.error(error, null, 6000)
    }
  }

  renderModalContentWhenCustomAmountSelected = () => (
    <div>
      <h5 style={{ color: 'orange' }}>لطفا میزان شارژ را به تومان وارد کنید</h5>

      <MoneyInput
        value={this.state.rechargeAmount}
        placeholder="میزان شارژ (تومان)"
        style={{ direction: 'ltr', padding: 5, width: '100%' }}
        onChange={this.updateRechargeAmount}
      />
      <br />
      <div>
        <PriceWithWords>{this.state.rechargeAmount}</PriceWithWords>
      </div>
    </div>
  )

  renderModalContentWhenSelectFromWidgets = () => (
    <div>
      <div>شارژ حساب به میزان:</div>
      <div>
        <PriceWithWords>{this.state.rechargeAmount}</PriceWithWords>
      </div>
    </div>
  )

  render() {
    const rechargeModalActions = [
      <Button bsStyle="primary" onClick={this.handlePayment}>
        پرداخت
      </Button>,
      <Button bsStyle="primary" outlined onClick={this.closeModal}>
        انصراف
      </Button>,
    ]

    const { rechargeRequest } = this.props

    return (
      <div>
        <Toolbar />

        <section className="credit-recharge-wrapper">
          <UserCredit />

          <RechargeCards onClick={this.onRechargeCardClick}>
            <CustomPriceCard
              key="custom-price"
              title="شارژ به میزان دلخواه"
              onClick={this.openModal}
            />
          </RechargeCards>
        </section>

        <Dialog
          title="افزایش اعتبار"
          actions={rechargeModalActions}
          modal={false}
          autoScrollBodyContent
          actionsContainerClassName="modal-actions"
          open={this.state.rechargeModalIsOpen}
          onRequestClose={this.closeModal}
          contentClassName="fatemi-modal"
        >
          {rechargeRequest ? (
            <div style={styles.spinner}>
              <PulseLoader color={'#00abde'} />
            </div>
          ) : (
            <div>
              {this.state.selectedFromWidgets
                ? this.renderModalContentWhenSelectFromWidgets()
                : this.renderModalContentWhenCustomAmountSelected()}
            </div>
          )}
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  rechargeRequest: state.userBalance.rechargeRequestAsyncCall,
})

export default connect(mapStateToProps)(StudentCreditPage)



// WEBPACK FOOTER //
// ./src/components/student/StudentCreditPage.js